import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { makeCall } from '../../auth-utils';
import { useToasts } from 'react-toast-notifications';
import { PageTitle } from '@galop/component-library';
import { AppName } from '../../App';
import { api, globalErrorHandler } from '../../api/create-api';

export const Callback = (props) => {
    const { CurrentUser } = props;
    const ls = require('local-storage');
    const { addToast } = useToasts();
    const [redirect, setRedirect] = useState(null);
    const path = ls('redirect-path');

    useEffect(() => {
        if (path && CurrentUser) {
            verifyRedirectURL();
        }
    }, [CurrentUser]);

    useEffect(() => {
        if (redirect) {
            ls.remove('redirect-path');
        }
    }, redirect);

    const verifyRedirectURL = () => {
        makeCall(async (authHeader) => {
            const results = await api(`api/utility/paths`, { headers: authHeader })
                .catch(error => globalErrorHandler(error, addToast));

            if (results && results.data) {
                const patterns = results.data.map(validPath => new RegExp(`^${validPath.replace('/', '\/')}/?(edit|view|search)?\/?[0-9A-Za-z\-]*`));
                const validPath = patterns.find(pattern => pattern.test(path || '/'));

                if (validPath) {
                    setRedirect(path || '/');
                }
            }
        });
    };

    return (
        <div>
            {redirect && <Redirect to={redirect} />}
            <PageTitle AppName={AppName} moduleName={`Logged In to ${AppName}`} />
            <p>Attempting to redirect to {path}...</p>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Shared/Callback.js